<template>
  <div class="addDiscount">
    <div class="page_title">发放优惠券</div>
    <div class="container">
      <el-form
        :model="form"
        style="min-width: 1000px"
        label-width="100px"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="优惠券名称">
          <span>{{ info.coupon_name }}</span>
        </el-form-item>
        <el-form-item label="使用时间">
          <span v-if="info.time_limit == 2"
            >{{ info.time_start }}至{{ info.time_end }}</span
          >
          <span v-if="info.time_limit == 1">领取后{{ info.time_days }}天</span>
        </el-form-item>
        <el-form-item label="优惠条件">
          <span>满{{ info.money }}减{{ info.enough }}元</span>
        </el-form-item>
        <el-form-item label="退还方式">
          <span v-if="info.return_type == 1">不可退回</span>
          <span v-if="info.return_type == 2">取消订单</span>
        </el-form-item>
        <el-form-item label="每人数量">
          <el-input-number
            v-model="form.num"
            step-strictly
            :step="1"
            :min="1"
            :max="99"
            :controls="false"
            placeholder="请输入数字"
          ></el-input-number>
          <span style="margin-left: 10px; color: #999">发放给每个人的数量</span>
        </el-form-item>
        <el-form-item label="发放通知">
          <el-radio v-model="is_send" label="0">不通知</el-radio>
          <el-radio v-model="is_send" label="1">短信通知</el-radio>
        </el-form-item>
        <el-form-item
          label="发放用户"
          :style="
            form.grant_type == 3 || form.grant_type == 4
              ? { height: '500px' }
              : { height: 'auto' }
          "
        >
          <el-radio-group v-model="form.grant_type" @input="clearType">
            <div>
              <el-radio label="3"
                >搜索用户<span style="color: red; margin-left: 5px"
                  >({{ giveList.length }})</span
                ></el-radio
              >
            </div>
            <div>
              <el-radio label="5"
                >按用户群体发放<span style="color: red; margin-left: 5px"
                  >({{ count5 || 0 }})</span
                >
                <span style="margin: 0 10px 0 20px" v-if="form.grant_type == 5"
                  >请选择用户群</span
                >
                <el-select
                  v-if="form.grant_type == 5"
                  v-model="chooseGroup"
                  multiple
                  placeholder="请选择"
                  @change="countPeople"
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item.label_id"
                    :label="item.label_name"
                    :value="item.label_id"
                  >
                  </el-option>
                </el-select>
              </el-radio>
            </div>
            <div>
              <el-radio label="4"
                >按手机号发放<span style="color: red; margin-left: 5px"
                  >({{ count4 || 0 }})</span
                ></el-radio
              >
            </div>
          </el-radio-group>
          <div class="inputBox" v-if="form.grant_type == 4">
            <el-input
              v-model="phoneList"
              type="textarea"
              style="min-height: 200px"
              @blur="countPeople"
            ></el-input>
          </div>
          <div class="transfer flex" v-if="form.grant_type == 3">
            <div class="left">
              <div class="top bb flex between">
                <div>未选用户</div>
                <span class="s1"
                  >{{ userCheckedLength }}/{{ userList.length }}</span
                >
              </div>
              <div class="body bb" ref="scrollDiv" @scroll="checkScroll">
                <el-input
                  v-model="phone_name"
                  placeholder="输入用户姓名/手机"
                  style="width: 150px"
                  @blur="chearPage()"
                ></el-input>
                <div class="list">
                  <div class="box" v-for="item in userList" :key="item.user_id">
                    <p class="flex align-center p1">
                      <el-checkbox v-model="item.checked"></el-checkbox>
                      {{ item.real_name }}{{ item.phone }}
                    </p>
                    <!-- <p class="p2 gray">已发放数：{{ item.count }}</p> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="center flex column column-center">
              <el-button-group>
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  :disabled="giveCheckedLength == 0"
                  @click="toLeft"
                ></el-button>
                <el-button
                  type="primary"
                  icon="el-icon-arrow-right"
                  :disabled="userCheckedLength == 0"
                  @click="toRight"
                ></el-button>
              </el-button-group>
            </div>
            <div class="right">
              <div class="top bb flex between">
                <div class="flex align-center">
                  <el-checkbox
                    v-model="giveCheck"
                    @change="setAllGiveListCheck"
                    style="margin-right: 5px"
                  ></el-checkbox
                  >已选用户
                </div>
                <span class="s1"
                  >{{ giveCheckedLength }}/{{ giveList.length }}</span
                >
              </div>
              <div class="body bb">
                <el-input
                  v-model="give_phone_name"
                  placeholder="输入用户姓名/手机"
                  style="width: 150px"
                  @input="filterGiveList"
                ></el-input>
                <div class="list">
                  <div
                    class="box"
                    v-for="item in giveList"
                    :key="item.user_id"
                    v-show="item.show"
                  >
                    <p class="flex align-center p1">
                      <el-checkbox v-model="item.checked"></el-checkbox>
                      {{ item.real_name }}{{ item.phone }}
                    </p>
                    <!-- <p class="p2 gray">已发放数：{{ item.count }}</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        
        <div class="submit flex center align-center">
          <el-button type="info" @click="cancel" size="medium">取消</el-button>
          <el-button type="primary" @click="submit" size="medium"
            >提交</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "addDiscount",
  data() {
    return {
      coupon_data_id: this.$route.query.coupon_data_id,
      info: {},
      form: { grant_type: "1", num: 1 },
      rules: {
        num: [{ required: true, message: "请输入发放数量", trigger: "blur" }],
      },
      phone_name: "",
      give_phone_name: "",
      userList: [], //查询的人
      giveList: [], //确认发放的人
      giveCheck: false, //确认发放全选
      groupList: [], //群列表
      chooseGroup: "", //已选择群体id
      phoneList: "", //输入的手机号码
      count4: "", //计算人数
      count5: "", //计算人数
      is_send: "0",
      nowPage: 1,
      totalPage: 0,
    };
  },
  created() {
    this.getCouponInfo();
    this.getGrantCouponUserLists();
    this.getGroupInfo();
  },
  computed: {
    userCheckedLength() {
      let data =
        this.userList.filter((ele) => {
          return ele.checked == true;
        }) || [];
      return data.length || 0;
    },
    giveCheckedLength() {
      let data =
        this.giveList.filter((ele) => {
          return ele.checked == true;
        }) || [];
      return data.length || 0;
    },
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    getCouponInfo() {
      let data = {
        coupon_data_id: this.coupon_data_id,
      };
      this.axios.post("platform/shop/getCouponDataInfo", data).then((res) => {
        let data = res.data.info;
        let info = {
          coupon_data_id: data.coupon_data_id,
          coupon_name: data.coupon_name || "",
          enough: data.enough,
          time_limit: data.time_limit,
          time_days: data.time_days,
          money: data.money,
          return_type: data.return_type,
          total: data.total,
        };
        if (data.time_start) {
          info.time_start = dayjs(data.time_start * 1000).format("YYYY-MM-DD");
          info.time_end = dayjs(data.time_end * 1000).format("YYYY-MM-DD");
        }
        this.info = info;
      });
    },
    getGroupInfo() {
      this.axios.post("platform/Userpreferential/getLabelList").then((res) => {
        this.groupList = res.data.list;
      });
    },
    countPeople() {
      if (!this.phoneList && !this.chooseGroup.length) {
        this.count4 = 0;
        this.count5 = 0;
        return;
      }
      let ids = "";
      if (this.form.grant_type == 4) {
        ids = this.phoneList;
      }
      if (this.form.grant_type == 5) {
        ids = this.chooseGroup.toString();
      }
      const data = {
        type: this.form.grant_type,
        ids: ids,
      };
      console.log("data", data);
      this.axios
        .post("platform/shop/getGrantCouponUserCount", data)
        .then((res) => {
          if (this.form.grant_type == 4) {
            this.count4 = res.data.count;
          }
          if (this.form.grant_type == 5) {
            this.count5 = res.data.count;
          }
        });
    },
    clearType() {
      this.phoneList = "";
      this.giveList = [];
      this.chooseGroup = "";
      this.count4 = "";
      this.count5 = "";
    },
    chearPage() {
      this.nowPage = 1;
      this.userList = [];
      this.getGrantCouponUserLists();
    },
    //查询人
    getGrantCouponUserLists() {
      let data = {
        page: this.nowPage,
        pageNumber: 40,
        coupon_data_id: this.coupon_data_id,
        keywords: this.phone_name,
      };
      console.log(data);
      this.axios.post("platform/shop/getAllUserList", data).then((res) => {
        let list = res.data.list;
        this.totalPage = res.data.totalPage;
        list.forEach((ele) => {
          ele.checked = false;
        });
        this.userList = [...this.userList, ...list];
      });
    },
    toLeft() {
      let giveList = [];
      this.giveList.forEach((ele) => {
        if (ele.checked) {
          let index = this.userList.findIndex((ele2) => {
            return ele2.user_id == ele.user_id;
          });
          if (index == -1) {
            let obj = {
              user_id: ele.user_id,
              real_name: ele.real_name,
              phone: ele.phone,
              count: ele.count,
              checked: false,
            };
            this.userList.unshift(obj);
          }
        } else {
          giveList.push(ele);
        }
      });
      this.giveList = giveList;
    },
    toRight() {
      let userList = [];
      this.userList.forEach((ele) => {
        if (ele.checked) {
          let index = this.giveList.findIndex((ele2) => {
            return ele2.user_id == ele.user_id;
          });
          if (index == -1) {
            let obj = {
              user_id: ele.user_id,
              real_name: ele.real_name,
              phone: ele.phone,
              count: ele.count,
              checked: false,
              show: true,
            };
            this.giveList.push(obj);
          }
        } else {
          userList.push(ele);
        }
      });
      this.userList = userList;
    },
    //筛选发放用户
    filterGiveList() {
      this.giveList.forEach((ele) => {
        let name = ele.real_name;
        if (name.match(this.give_phone_name)) {
          ele.show = true;
        } else {
          ele.show = false;
        }
        if (!this.give_phone_name) {
          ele.show = true;
        }
      });
    },
    checkScroll() {
      const scrollDiv = this.$refs.scrollDiv;
      if (scrollDiv.scrollTop + scrollDiv.clientHeight >= scrollDiv.scrollHeight - 1) {
        // 当滚动到底部时触发
        this.onScrollToBottom();
      }
    },
    onScrollToBottom() {
      console.log("滚动到底部了！");
      if (this.totalPage <= this.nowPage) {
        return;
      }
      this.nowPage = this.nowPage + 1;
      this.getGrantCouponUserLists();
      // 执行其他逻辑
    },
    //全选发放用户
    setAllGiveListCheck() {
      this.giveList.forEach((ele) => {
        ele.checked = this.giveCheck;
      });
    },
    //提交表单
    submit() {
      if (this.loading) return;
      let check = false;
      this.$refs.ruleForm.validate((valid) => {
        check = valid;
      });
      if (!check) {
        return;
      }
      this.loading = true;
      let data = {
        coupon_data_id: this.coupon_data_id,
        grant_type: this.form.grant_type,
        num: this.form.num,
        is_send: this.is_send,
      };
      if (data.grant_type == 3 && this.giveList.length == 0) {
        this.$message.error("请选择发放的人");
        return;
      } else if (data.grant_type == 3 && this.giveList.length != 0) {
        let arr = this.giveList.map((ele) => {
          return ele.user_id;
        });
        data.user_ids = arr.toString();
      }
      if (data.grant_type == 4 && this.phoneList.length == 0) {
        this.$message.error("请输入手机号码");
        return;
      } else if (data.grant_type == 4 && this.phoneList.length != 0) {
        data.user_ids = this.phoneList;
      }
      if (data.grant_type == 5 && this.chooseGroup.length == 0) {
        this.$message.error("请选择群体");
        return;
      } else if (data.grant_type == 5 && this.chooseGroup.length != 0) {
        console.log("this.chooseGroup", this.chooseGroup);
        data.user_ids = this.chooseGroup.toString();
      }
      console.log("data", data);
      this.axios
        .post("platform/shop/grantUserCoupon", data)
        .then(() => {
          this.$message.success("发放成功");
          this.loading = false;
          this.$router.push("./discountsList");
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.addDiscount {
  text-align: left;
  padding: 20px;
  border-radius: 5px;
}
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 20px);
  padding: 20px;
}
.el-input,
.el-input-number,
.el-cascader {
  width: 250px;
  margin-right: 5px;
}

.submit {
  // margin: 30px 0;
}
.transfer {
  margin-top: 5px;
  width: 600px;
  .left,
  .right {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    display: inline-block;
    vertical-align: middle;
    width: 200px;
    max-height: 100%;
    box-sizing: border-box;
    position: relative;
    .top {
      width: 200px;
      height: 40px;
      padding: 0 15px;
      line-height: 40px;
      background: #f5f7fa;
      margin: 0;
      padding-left: 15px;
      border-bottom: 1px solid #ebeef5;
      box-sizing: border-box;
      color: #000;
      .s1 {
        color: #909399;
        font-size: 12px;
        font-weight: normal;
      }
    }
    .body {
      padding: 15px;
      height: 300px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .p1 {
        .el-checkbox {
          margin-right: 10px;
        }
      }
      .p2 {
        font-size: 12px;
        padding-left: 25px;
      }
    }
  }
  .center {
    width: 120px;
  }
}
.el-radio {
  margin-bottom: 15px;
}
</style>
<style>
.el-textarea__inner {
  min-height: 300px !important;
  margin-bottom: 20px;
}
.el-form-item__content{
  height: fit-content;
}
</style>
